import { authButton } from '../../theme';

const styles = {
  button: authButton,
  container: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
};

export default styles;
